export default __webpack_public_path__ + "static/media/logo.faf4db47.svg";